/**
 * @file: index.tsx
 *
 * `ChatThreadListScreen` — a standalone navigator binding for the thread list
 * that opens a tapped thread as a conversation. Not currently mounted (the
 * inbox embeds `ChatThreadListView` directly with its own master-detail
 * selection), but kept here so a future surface can route to the list as a
 * page. The view itself (re-exported here) is navigation-agnostic and lives
 * in `./components`.
 */

import { conversationIntentForThread } from '@euler/app/flows/chat/lib/conversation/types';
import { useOpenChatConversation } from '@euler/app/flows/chat/lib/navigation/openChatConversation';
import { useChatSession } from '@euler/app/flows/chat/lib/session/context';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { ChatThreadListView } from './components/ChatThreadListView';

export { ChatThreadListView };

export const ChatThreadListScreen = wrapNavigatorScreen(
  () => {
    const openConversation = useOpenChatConversation();
    const { me } = useChatSession();
    const selfName = me.user.name;
    return (
      <ChatThreadListView
        onOpenThread={thread =>
          openConversation(conversationIntentForThread(thread, selfName))
        }
      />
    );
  },
  { title: '聊天消息' },
);
